var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCallOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 11,
    viewBox: "0 0 24 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17009 10.6611L7.29108 9.02139C7.98991 8.65492 8.36647 7.76253 8.18683 6.90087C8.0413 6.20108 8.17098 5.45277 8.53361 4.89899C8.7824 4.51955 9.12101 4.26835 9.487 4.1915C11.107 3.85193 12.7502 3.84953 14.3688 4.18382C14.7347 4.25971 15.0729 4.50946 15.3202 4.88842C15.6814 5.44076 15.8087 6.18859 15.6608 6.88982C15.4792 7.75148 15.8529 8.64196 16.5503 9.00698L19.666 10.6366C20.3562 10.9983 21.1852 10.7562 21.6362 10.0603L23.4344 7.28991C23.4728 7.23132 23.5084 7.16984 23.5401 7.10548L23.6001 6.97532C23.6169 6.93449 23.6323 6.8903 23.6462 6.84275C23.8042 6.30434 23.6597 5.71213 23.2778 5.33412C22.7793 4.84135 22.2538 4.37642 21.7149 3.95088L21.5699 3.76452L21.5684 3.76404L21.4733 3.76404C18.605 1.57868 15.3106 0.427402 11.9341 0.432205C8.48606 0.437488 5.12204 1.64784 2.20327 3.93262C1.64564 4.36922 1.10194 4.84855 0.587062 5.35671C0.585141 5.35863 0.583221 5.36055 0.580819 5.36295C0.190336 5.75344 0.0419229 6.37446 0.211949 6.91336C0.223956 6.94938 0.235963 6.98348 0.248931 7.0147C0.29408 7.12421 0.349314 7.22939 0.411273 7.32497L2.20231 10.091C2.65187 10.7846 3.47942 11.0242 4.17009 10.6611Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCallOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/call-off.72d04c66224b8b62d08e0c3d762038bd.svg";